module.exports = __webpack_public_path__ + "static/media/Sarah Gonzalez Headshot.78339a32.jpeg";